"use strict";
/**
 * WP-077: Compliance Requirements & Renewal Tracking
 *
 * Types for school compliance management — defining requirements like
 * "all teaching staff must complete Safeguarding Level 1 every 12 months"
 * and tracking individual staff completions with computed status.
 *
 * Design decisions (see WP-077 spec):
 * - `completedDate` and `expiryDate` are DATE (YYYY-MM-DD), not TIMESTAMP,
 *   to eliminate DST/timezone issues.
 * - `status` is computed on read (SQL CASE WHEN), not stored.
 * - `targetCompletionPct` replaces `isStatutory` (less legally prescriptive).
 * - `renewalPeriodMonths` is a single integer (null = one-off, never expires).
 * - Soft delete via `isActive` on both tables.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.COMPLIANCE_STATUSES = void 0;
exports.isComplianceRecordStatus = isComplianceRecordStatus;
/**
 * Constant array of all valid ComplianceRecordStatus values.
 */
exports.COMPLIANCE_STATUSES = [
    'pending',
    'completed',
    'expiring',
    'expired',
];
/**
 * Type guard: returns true if the value is a valid ComplianceRecordStatus.
 */
function isComplianceRecordStatus(value) {
    return typeof value === 'string' && exports.COMPLIANCE_STATUSES.includes(value);
}
